import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { SiteUser, UserLogo, UserResponse } from '../../../model/user';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MockUserService extends UserService {

  constructor() { 
    super();
  }
  getUsers(): Observable<SiteUser[]> {
    throw new Error('Method not implemented.');
  }

  getUserLogos(): Observable<UserLogo[]> {
    throw new Error('Method not implemented.');
  }

  saveUserLogo(userId: number, logoId: number) {
    throw new Error('Method not implemented.');
  }
}